import { render, staticRenderFns } from "./BidsByCreator.vue?vue&type=template&id=5d539a6f"
import script from "./BidsByCreator.vue?vue&type=script&lang=js"
export * from "./BidsByCreator.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports